export default class NoopAnalyticsService {
  trackEvent() {}

  trackPage() {}
}
